import React from "react";
import LegalPageLayout from "@/components/LegalPageLayout";
import { LEGAL_CONTENT } from "@/data/legalContent";

// Public, unauthenticated route — /privacy
const Privacy = () => {
  const c = LEGAL_CONTENT.privacy;
  return <LegalPageLayout topicKey="privacy" title={c.title} body={c.body} />;
};

export default Privacy;
